document.addEventListener('click', function (e) {
	var btn = e.target.closest('.video-mute-toggle');
	if (!btn) return;

	var scope = btn.closest('[data-video-mute-scope]');
	if (!scope) return;
	var container = scope.hasAttribute('data-provider') ? scope : scope.querySelector('[data-provider]');
	if (!container) return;

	var unmuted = btn.classList.toggle('is-unmuted');
	setVideoMuted(container, !unmuted);

	btn.setAttribute('aria-pressed', String(unmuted));
	btn.setAttribute('aria-label', unmuted ? btn.dataset.labelOff : btn.dataset.labelOn);
});

function setVideoMuted(container, muted) {
	var provider = container.dataset.provider;
	var iframe = container.querySelector('iframe');
	var video = container.querySelector('video');

	if (provider === 'youtube' && iframe && iframe.contentWindow) {
		iframe.contentWindow.postMessage(JSON.stringify({
			event: 'command',
			func: muted ? 'mute' : 'unMute',
			args: ''
		}), '*');
	} else if (provider === 'vimeo' && iframe && iframe.contentWindow) {
		iframe.contentWindow.postMessage(JSON.stringify({
			method: 'setMuted',
			value: muted
		}), '*');
	} else if (provider === 'hosted' && video) {
		video.muted = muted;
	}
}
